var map = {
	"./Avatars": 2399,
	"./Avatars.stories": 65046,
	"./Avatars.stories.tsx": 65046,
	"./Avatars.tsx": 2399,
	"./NFT": 54081,
	"./NFT.tsx": 54081,
	"./TheAngel.png": 18817,
	"./TheAngelTest.png": 97697,
	"./TheFounder.png": 68675,
	"./TheFounderTest.png": 45567,
	"./TheHodler.png": 31954,
	"./TheHodlerTest.png": 93374,
	"./TheInvestor.png": 66640,
	"./TheInvestorTest.png": 35984,
	"./TheTrader.png": 66140,
	"./TheTraderTest.png": 25956,
	"./mystery.png": 9362,
	"./mystery1.png": 54321,
	"./mystery1Test.png": 87505,
	"./mysteryTest.png": 53726,
	"./videos/Monsoon.mp4": 91586,
	"./videos/Science.mp4": 88567,
	"./videos/Space.mp4": 27451,
	"./videos/Summer.mp4": 63118,
	"./videos/Winter.mp4": 71006,
	"./videos/ape.mp4": 87537,
	"./videos/eagle.mp4": 67845,
	"./videos/rhino.mp4": 48511,
	"./videos/shark.mp4": 62918,
	"./videos/tiger.mp4": 41988,
	"assets/avatars/Avatars.stories": 65046,
	"assets/avatars/Avatars.stories.tsx": 65046,
	"assets/avatars/Avatars.tsx": 2399,
	"assets/avatars/NFT.tsx": 54081,
	"assets/avatars/TheAngel.png": 18817,
	"assets/avatars/TheAngelTest.png": 97697,
	"assets/avatars/TheFounder.png": 68675,
	"assets/avatars/TheFounderTest.png": 45567,
	"assets/avatars/TheHodler.png": 31954,
	"assets/avatars/TheHodlerTest.png": 93374,
	"assets/avatars/TheInvestor.png": 66640,
	"assets/avatars/TheInvestorTest.png": 35984,
	"assets/avatars/TheTrader.png": 66140,
	"assets/avatars/TheTraderTest.png": 25956,
	"assets/avatars/mystery.png": 9362,
	"assets/avatars/mystery1.png": 54321,
	"assets/avatars/mystery1Test.png": 87505,
	"assets/avatars/mysteryTest.png": 53726,
	"assets/avatars/videos/Monsoon.mp4": 91586,
	"assets/avatars/videos/Science.mp4": 88567,
	"assets/avatars/videos/Space.mp4": 27451,
	"assets/avatars/videos/Summer.mp4": 63118,
	"assets/avatars/videos/Winter.mp4": 71006,
	"assets/avatars/videos/ape.mp4": 87537,
	"assets/avatars/videos/eagle.mp4": 67845,
	"assets/avatars/videos/rhino.mp4": 48511,
	"assets/avatars/videos/shark.mp4": 62918,
	"assets/avatars/videos/tiger.mp4": 41988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99866;